export const IRB_PRESENTATION = "IRBPresentation";
export const DATE_OF_IRB_SUBMISSION = "dateOfIRBSubmission";
export const DEPARTMENT = "department";
export const DEPARTMENT_OTHERS = "departmentOthers";
export const EMAILS = "emails";
export const FUND_TYPE = "fundType";
export const IS_FUNDED = "isFunded";
export const IS_TERMS_ACCEPTED = "isTermsAccepted";
export const PRINCIPAL_INVESTIGATOR = "principalInvestigator";
export const CO_INVESTIGATOR = "coInvestigator";
export const PRINCIPAL_INVESTIGATOR_OTHERS = "principalInvestigatorOthers";
export const PROTOCOL_NUMBER = "protocolNumber";
export const PROTOCOL_NUMBER_OTHERS = "protocolNumberOthers";
export const SPONSOR = "sponsor";
export const SPONSOR_OTHERS = "sponsorOthers";
export const STUDY_PHASE = "studyPhase";
export const STUDY_PHASE_OTHER = "studyPhaseOther";
export const TITLE = "title";
export const TYPE_OF_STUDY = "typeOfStudy";
export const TYPE_OF_STUDY_OTHER = "typeOfStudyOther";
export const TYPE_OF_PV_PD = "typeOfPvPd";
export const DOCUMENTS = "documents";
export const LABEL = "label";
export const REMARK = "remark";
export const _URL = "url";
export const REQUIRED = "required";
export const IS_DELETABLE = "isDeletable";
export const IS_EDITABLE = "isEditable";
export const DROPDOWN_VALUES = "dropdownValues";
export const DROPDOWN_SELECTED_VALUE = "dropdownSelectedValue";
export const IS_INPUT_OPENED = "isInputOpened";
export const MICR = "micr";
export const DATE = "date";
export const DATE_OF_EVENT = "dateOfEvent";
export const DATE_OF_RESIGNATION = "dateOfResignation";
export const REASON_FOR_RESIGNATION = "reasonForResignation";
export const RESIGN_LETTER = "resignLetter";
export const EMAIL = "email";
export const PASSWORD = "password";
export const NAME = "name";
export const AVATAR = "avatar";
export const MEMBER_TYPE = "memberType";
export const QUALIFICATION = "qualification";
export const QUALIFICATION_REGISTRATION = "QualificationRegistration";
export const IS_AFFILIATED_TO_MEDANTA = "isAffiliatedToMedanta";
export const ROLES_IN_EC = "rolesInEC";
export const ROLES_IN_EC_OTHERS = "rolesInECOthers";
export const DATE_OF_APPOINTMENT = "dateOfAppointment";
export const DATE_OF_TENURE_COMPLETION = "dateOFTenureCompletion";
export const SIGNED_CONFIDENTIALITY_AGREEMENT = "signedConfidentialityAgreement";
export const SIGNED_CONFLICT_OF_INTEREST = "signedConflictOfInterest";
export const MEDICAL_REGISTRATION_CERTIFICATE = "medicalRegistrationCertificate";
export const CV = "cv";
export const GCP_CERTIFICATE = "GCPCertificate";
export const GCP_CERTIFICATE_1 = "GCPCertificate1";
export const GCP_CERTIFICATE_2 = "GCPCertificate2";
export const DATE_OF_CERTIFICATION = "dateOfCertification";
export const VALID_UPTO = "validUpto";
export const NEXT_GCP_CERTIFICATE_DUE_ON = "nextGCPCertificateDueOn";
export const TRAININGS = "trainings";
export const ROLE = "role";